import {
	setDocumentId,
	setDocumentTypeSelected,
} from 'feature/upload/uploadSlice';
import { useFileOpener } from 'hooks/downloader.hook';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store/store';
import { Box, Stack, Typography } from 'styles';
import { IFileType } from 'types/Claim';
import { STATE_KEYS } from 'types/Store';
import { DocType } from 'types/Upload';
import { TRANSLATION_KEYS } from 'utils/constants';
import { camelcaseToUnderscore } from 'utils/utils';
import AfterUpload from './AfterUpload';
import BeforeUpload from './BeforeUpload';

type DocumentationClaimProps = {
	label: string;
	labelUpload: string;
	documentType: DocType;
	data?: IFileType;
	clearDocumentsKey?: STATE_KEYS;
	showIcon?: boolean;
};

const UploadFileTile: FC<DocumentationClaimProps> = ({
	label,
	documentType,
	data,
	clearDocumentsKey,
	showIcon = true,
}) => {
	const dispatch = useDispatch<AppDispatch>();

	const documentUuid = data?.uuid;
	const fileName = data?.fileName;
	const [isEditMode, setIsEditMode] = useState(false);
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});

	const fileOpener = useFileOpener();
	const handlerDownloadFile = () => {
		const url = `${
			process.env.REACT_APP_API_URL
		}/attachments/${camelcaseToUnderscore(documentType)}/${documentUuid}/content`;

		fileOpener({ url, fileName: fileName! });
	};

	return (
		<Box width={'100%'} minHeight={{ sm: '210px', lg: '240px' }}>
			{!data?.uuid ? (
				<BeforeUpload documentType={documentType} showIcon={showIcon} />
			) : (
				<AfterUpload
					isEditMode={isEditMode}
					enableEditModeAction={() => setIsEditMode(true)}
					enableDialogAction={() => {
						dispatch(setDocumentId(documentUuid));
						dispatch(setDocumentTypeSelected(documentType));
					}}
					label={label}
					canDownloadFile
					handlerDownloadFile={handlerDownloadFile}
					data={data}
					documentType={documentType}
					setIsEditMode={setIsEditMode}
					clearDocumentsKey={clearDocumentsKey}
				/>
			)}
			{!showIcon && (
				<Stack direction={'row'} justifyContent={'space-between'}>
					<Typography variant="caption">
						{tClientLabels('beforeUpload.supportedFormats')}
					</Typography>
					<Typography variant="caption">
						{tClientLabels('beforeUpload.maxFileSize')}
					</Typography>
				</Stack>
			)}
		</Box>
	);
};

export default UploadFileTile;
